module.exports = __webpack_public_path__ + "media/images/home/icon-play-triangle-58e8f6042d3c1f86f58c06632e14f75d.svg";